import React, { Component } from "react";
import {
  // TabContent,
  // TabPane,
  Collapse,
  // NavLink,
  // NavItem,
  // CardText,
  // Nav,
  // Input,
  Button,
  Card,
  Row,
  Col,
  CardBody,
  CardHeader,
  Container,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { connect } from "react-redux";
import Switch from "react-switch";
import { Link } from "react-router-dom";

import Swal from "sweetalert2";
// import classnames from "classnames";
// import Breadcrumbs from "../../../components/Common/Breadcrumb";

import AdminSidebar from "../../AdminSidebar/AdminSidebar";

import "./AddProfile.scss";
import {
  GetPermstionsList,
  checkPermssion,
  permissionFiled,
  InputChangeValue,
  SubmitProfile,
  getProfiledata,
} from "../../../../store/CompanySettings/Profiles/actions";

// import CompanyDetails from "./CompanyDetails";
// import Users from "./Users";
// import Profile from "./Profile";

class AddProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "1",
      col: [
        {
          id: 1,
        },
      ],
      // col1: true,
      // col2: false,
      // col3: false,
    };

    this.t_col1 = this.t_col1.bind(this);
  }
  t_col1(item) {
    var arr = this.state.arr.map((i, idx) => {
      if (i.id === item.id) {
        if (i.titlecol === true) {
          i.titlecol = !i.titlecol;
        } else {
          i.titlecol = !i.titlecol;
        }
      } else {
        i.titlecol = false;
      }

      return i;
    });
    this.setState({ arr: arr });
  }

  //----------------
  componentDidMount() {
    this.props.GetPermstionsList(this.props.match.params.id);
    // if (this.props.match.params.id !== "0") {
    //   this.props.getProfiledata(this.props.match.params.id);
    // }
  }
  handleProfileChange(e) {
    this.props.InputChangeValue({
      key: e.target.name,
      value: e.target.value,
    });

    this.setState({
      ErrorMessage: null,
    });
  }
  handleSubmit() {
    var permission_ids = [];
    permission_ids = this.props.checkedPermissions.map((permission) => {
      return permission.id;
    });
    if (
      this.props.ProfileRowData.name == null ||
      this.props.ProfileRowData.name === ""
    ) {
      this.setState({
        ErrorMessage: "Enter Profile Name",
      });
    } else {
      if (permission_ids.length === 0) {
        Swal.fire({
          icon: "error",
          text: "Select Permissions!",
        });
      } else {
        var data = {
          name: this.props.ProfileRowData.name,
          permission_ids: permission_ids,
        };

        this.props.SubmitProfile(
          data,
          this.props.match.params.id,
          this.props.history
        );
      }
    }
  }
  renderPermissons() {
    var x = "";
    return this.props.persmsitonsList.map((item, index) => {
      if (item.app_label !== x) {
        x = item.app_label;
        return (
          <>
            <h3 className="card-title-18 pt-4">{item.app_label} Permission</h3>
            <hr className="my-1" />

            {this.renderPermissonsCard(item, index)}
          </>
        );
      } else {
        return this.renderPermissonsCard(item, index);
      }
    });
  }
  renderPermissonsCard(item, index) {
    return (
      <div id="accordion" className="mt-2">
        <Card className="mb-1" key={item.id}>
          <CardHeader className="bg-transparent border-bottom">
            <div className="m-0 ">
              <Row>
                <Col md={3}>
                  <i className="mdi mdi-account-box-outline mdi-18px mr-2"></i>
                  <h5 className="d-inline-block">{item.model}</h5>
                  <label className="d-inline-block float-right">
                    <Switch
                      checked={item.commonFalse}
                      onChange={() => this.props.checkPermssion(item.id)}
                      handleDiameter={10}
                      height={20}
                      width={42}
                      className="react-switch"
                    />
                  </label>
                </Col>
                <Col md={7}>
                  {item.permissions.map((permissions) => (
                    <label htmlFor="See-switch" className="font-size-16 ml-1">
                      <Switch
                        checked={permissions.checked}
                        onChange={() =>
                          this.props.permissionFiled(item.id, permissions.id)
                        }
                        disabled={item.commonFalse === true ? false : true}
                        onColor="#86d3ff"
                        onHandleColor="#2693e6"
                        handleDiameter={20}
                        // uncheckedIcon={false}
                        // checkedIcon={false}
                        boxShadow="0px 1px 3px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 5px rgba(0, 0, 0, 0.2)"
                        height={10}
                        width={28}
                        className="react-switch mr-2"
                        id="material-switch"
                      />
                      <span>{permissions.name}</span>
                    </label>
                  ))}

                  {/* <label htmlFor="Create-switch" className="font-size-16 ml-1">
                    <Switch
                      checked={item.checkedCreate}
                      onChange={() => this.handleChangeCreate(item)}
                      disabled={item.createDisabled}
                      onColor="#86d3ff"
                      onHandleColor="#2693e6"
                      handleDiameter={20}
                      uncheckedIcon={false}
                      checkedIcon={false}
                      boxShadow="0px 1px 3px rgba(0, 0, 0, 0.6)"
                      activeBoxShadow="0px 0px 1px 5px rgba(0, 0, 0, 0.2)"
                      height={10}
                      width={28}
                      className="react-switch mr-2"
                      id="material-switch"
                    />
                    <span>Create</span>
                  </label>
                  <label htmlFor="Modify-switch" className="font-size-16 ml-1">
                    <Switch
                      checked={item.checkedModify}
                      onChange={() => this.handleChangeModify(item)}
                      disabled={item.modifyDisabled}
                      onColor="#86d3ff"
                      onHandleColor="#2693e6"
                      handleDiameter={20}
                      uncheckedIcon={false}
                      checkedIcon={false}
                      boxShadow="0px 1px 3px rgba(0, 0, 0, 0.6)"
                      activeBoxShadow="0px 0px 1px 5px rgba(0, 0, 0, 0.2)"
                      height={10}
                      width={28}
                      className="react-switch mr-2"
                      id="material-switch"
                    />
                    <span>Modify</span>
                  </label>
                  <label htmlFor="Delete-switch" className="font-size-16 ml-1">
                    <Switch
                      checked={item.checkedDelete}
                      onChange={() => this.handleChangeDelete(item)}
                      disabled={item.deleteDisabled}
                      onColor="#86d3ff"
                      onHandleColor="#2693e6"
                      handleDiameter={20}
                      uncheckedIcon={false}
                      checkedIcon={false}
                      boxShadow="0px 1px 3px rgba(0, 0, 0, 0.6)"
                      activeBoxShadow="0px 0px 1px 5px rgba(0, 0, 0, 0.2)"
                      height={10}
                      width={28}
                      className="react-switch mr-2"
                      id="material-switch"
                    />
                    <span>Delete</span>
                  </label> */}
                </Col>
                <Col md={2}>
                  <Link
                    to="#"
                    onClick={() => this.t_col1(item)}
                    // checkedtext={this.checkedtext}
                    className={item.linkcol ? "enabled-link" : "disabled-link"}
                    // style={{ cursor: "pointer" }}
                  >
                    <p className="float-right mr-2">
                      <span>{item.titlecol ? "Hide All" : "View All"}</span>{" "}
                      <i
                        className={
                          item.titlecol
                            ? "mdi mdi-minus accor-plus-icon ml-2"
                            : "mdi mdi-plus accor-plus-icon ml-2"
                        }
                      ></i>
                    </p>
                  </Link>
                </Col>
              </Row>
            </div>
          </CardHeader>

          <Collapse isOpen={item.titlecol}>
            <CardBody>
              <h3 className="card-title-15 pt-2">Field Permission</h3>
              <Row>
                <Col md={6}>
                  <div className="m-2">
                    <Row>
                      <Col md={4}>
                        <p className="d-inline-block">Company Name :</p>
                      </Col>
                      <Col md={8}>
                        <div className="float-left">
                          <label htmlFor="label1" className="font-size-14 ml-1">
                            <input
                              type="radio"
                              value="Male"
                              name="label1"
                              className="redio-switch"
                            />
                            <span className="redio-switch">See & Modify</span>
                          </label>
                          <label htmlFor="label1" className="font-size-14 ml-1">
                            <input
                              type="radio"
                              value="female"
                              name="label1"
                              className="redio-switch"
                            />
                            <span className="redio-switch">Only See</span>
                          </label>
                          <label
                            htmlFor="label1"
                            className="font-size-14 ml-1 "
                          >
                            <input
                              type="radio"
                              value="female"
                              name="label1"
                              className="redio-switch"
                            />
                            <span className="redio-switch">Hidden</span>
                          </label>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="m-2">
                    <Row className="justify-content-center">
                      <Col md={4}>
                        <p className="font-size-16  d-inline-block">
                          Website :
                        </p>
                      </Col>
                      <Col md={8}>
                        <div className="float-left">
                          <label
                            htmlFor="WebsiteRadio"
                            className="font-size-14 ml-1"
                          >
                            <input
                              type="radio"
                              value="Male"
                              name="WebsiteRadio"
                              className="redio-switch"
                            />
                            <span className="redio-switch">See & Modify</span>
                          </label>
                          <label
                            htmlFor="WebsiteRadio"
                            className="font-size-14 ml-1"
                          >
                            <input
                              type="radio"
                              value="female"
                              name="WebsiteRadio"
                              className="redio-switch"
                            />
                            <span className="redio-switch">Only See</span>
                          </label>
                          <label
                            htmlFor="WebsiteRadio"
                            className="font-size-14 ml-1 "
                          >
                            <input
                              type="radio"
                              value="female"
                              name="WebsiteRadio"
                              className="redio-switch"
                            />
                            <span className="redio-switch">Hidden</span>
                          </label>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Collapse>
        </Card>
      </div>
    );
  }

  render() {
    return (
      <React.Fragment>
        <Row className="no-gutters">
          <Col md={1}>
            <AdminSidebar />
          </Col>
          <Col md={11} className="pl-5">
            <div className="page-content">
              <Container fluid>
                {/* <Breadcrumbs
              title="Add Profile"
              breadcrumbItems={this.state.breadcrumbItems}
            /> */}

                <Row>
                  <Col lg={12}>
                    <Card>
                      <CardHeader className="bg-transparent border-bottom">
                        <div className="float-right">
                          <Button
                            type="submit"
                            color="primary"
                            className="mr-2"
                            onClick={() => this.handleSubmit()}
                          >
                            Save
                          </Button>
                          <Button type="submit" color="light" href="/Users">
                            Cancel
                          </Button>
                        </div>
                        <h3 className="card-title-18 pt-2">Add Profile</h3>
                      </CardHeader>
                      <CardBody className="pt-2">
                        <Row>
                          <Col md={6}>
                            <FormGroup row className="m-3">
                              <Col md={6}>
                                <Label
                                  htmlFor="pName"
                                  className="col-form-label float-right font-size-18"
                                >
                                  Profile Name:
                                </Label>
                              </Col>
                              <Col md={6}>
                                <Input
                                  name="name"
                                  type="text"
                                  className="form-control"
                                  id="Name"
                                  value={this.props.ProfileRowData.name}
                                  placeholder="Enter Name"
                                  onChange={(e) => this.handleProfileChange(e)}
                                />
                                {this.state.ErrorMessage != null && (
                                  <span className="text-danger">
                                    {this.state.ErrorMessage}
                                  </span>
                                )}
                              </Col>
                            </FormGroup>
                            {/* <hr className="my-3" /> */}
                          </Col>
                          <Col md={12}>{this.renderPermissons()}</Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Container>
            </div>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { persmsitonsList, checkedPermissions, ProfileRowData } = state.Profile;

  return { persmsitonsList, checkedPermissions, ProfileRowData };
};
export default connect(mapStatetoProps, {
  GetPermstionsList,
  checkPermssion,
  permissionFiled,
  InputChangeValue,
  SubmitProfile,
  getProfiledata,
})(AddProfile);
